const startOfToday = () => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return now;
};

const dateOf = (appointment) => {
  if (!appointment?.date) return null;
  const parsed = new Date(appointment.date);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/** An appointment with no date is still work to do, so it counts as upcoming rather than vanishing. */
export const isUpcoming = (appointment, today = startOfToday()) => {
  const date = dateOf(appointment);
  return date === null || date >= today;
};

export const splitByWhen = (appointments, today = startOfToday()) => {
  const upcoming = [];
  const past = [];
  (appointments || []).forEach((appointment) => {
    (isUpcoming(appointment, today) ? upcoming : past).push(appointment);
  });
  const byDate = (direction) => (a, b) => {
    const left = dateOf(a);
    const right = dateOf(b);
    if (!left || !right) return left ? 1 : -1;
    return direction * (left - right);
  };
  return { upcoming: upcoming.sort(byDate(1)), past: past.sort(byDate(-1)) };
};

export const timeRange = (start, end) => {
  if (!start) return null;
  return end ? `${start} – ${end}` : start;
};

/** Day and month for the date block on each row; a dateless appointment says so plainly. */
export const dateParts = (appointment) => {
  const date = dateOf(appointment);
  if (!date) return { day: "--", month: "TBC" };
  return {
    day: String(date.getDate()).padStart(2, "0"),
    month: date.toLocaleDateString("en-AU", { month: "short" }).toUpperCase(),
  };
};

/** Only a web link is rendered as one; anything else (e.g. a javascript: URL) is not clickable. */
export const safeMeetLink = (value) => (/^https?:\/\//i.test(value || "") ? value : null);

/** Mirrors the server: only an upcoming meeting the partner booked, and not already closed. */
export const canCancel = (appointment, today = startOfToday()) =>
  Boolean(appointment?.bookedByYou) &&
  !["CANCELLED", "COMPLETED"].includes(appointment?.status) &&
  isUpcoming(appointment, today);
